export const siteLoaders = {};